module.exports = __webpack_public_path__ + "img/premium-icon-active.07c7947a.svg";